import { render, staticRenderFns } from "./enterInfo.vue?vue&type=template&id=bc813c72&scoped=true"
import script from "./enterInfo.vue?vue&type=script&lang=js"
export * from "./enterInfo.vue?vue&type=script&lang=js"
import style0 from "./enterInfo.vue?vue&type=style&index=0&id=bc813c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc813c72",
  null
  
)

export default component.exports